import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/planejamentoEstrategico/indicadores/'

class ObjetivoEstrategicoIndicadoresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getObjetivoEstrategico() {
        return this.conex.get(urlReceita + 'objetivoEstrategico/')
    }
}

export default ObjetivoEstrategicoIndicadoresService
